// @flow

import { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import CustomEvent from 'custom-event';
import StorylineQuery from '../Wheel/StorylineQuery';

/* eslint-disable no-unused-vars, class-methods-use-this */
class GlobalEvents extends PureComponent {
  static defaultProps = {
    storyline: [],
    location: {
      pathname: '',
      hash: '',
    },
    history: {
      push: () => {},
      goBack: () => {},
    },
  };

  static propTypes = {
    storyline: PropTypes.arrayOf(
      PropTypes.shape({
        entityLabel: PropTypes.string.isRequired,
        fieldSubtitle: PropTypes.string.isRequired,
        fieldThemeColor: PropTypes.string.isRequired,
        entityUrl: PropTypes.shape({
          alias: PropTypes.string.isRequired,
        }),
      }),
    ),
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      hash: PropTypes.string.isRequired,
    }),
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
      goBack: PropTypes.func.isRequired,
    }),
  };

  constructor(props) {
    super(props);

    this.currentStoryline = 0;
    this.isScrollingUp = false;
    this.previousScroll = 0;

    // Debounce the scrolling for a smoother experience.
    const debounce = require('lodash.debounce'); // eslint-disable-line global-require
    this.handleScroll = debounce(this.handleScroll, 125);
  }

  componentDidMount() {
    global.addEventListener(
      'previousStoryline',
      this.previousStoryline.bind(this),
    );
    global.addEventListener('nextStoryline', this.nextStoryline.bind(this));
    global.addEventListener('closeModal', this.closeModal.bind(this));
    global.addEventListener(
      'runKineticAnimations',
      this.runKineticAnimations.bind(this),
    );
    global.addEventListener('mapModalsClosed', this.closeMapModals.bind(this));
    global.addEventListener('keydown', this.handleKeyDown.bind(this));
    global.addEventListener('scroll', this.handleScroll.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (global.document) {
      global.document.documentElement.classList.remove('js-scrolled');
      global.document.documentElement.classList.remove(
        'js-play-intro-animation',
      );
    }

    if (typeof global.ga === 'function') {
      if (
        nextProps.location.pathname !== this.props.location.pathname ||
        nextProps.location.hash !== this.props.location.hash
      ) {
        global.ga(
          'set',
          'page',
          nextProps.location.pathname + nextProps.location.hash,
        );
        global.ga('send', 'pageview');
      }
    }
  }

  componentWillUnmount() {
    global.removeEventListener(
      'previousStoryline',
      this.previousStoryline.bind(this),
    );
    global.removeEventListener('nextStoryline', this.nextStoryline.bind(this));
    global.removeEventListener('closeModal', this.closeModal.bind(this));
    global.removeEventListener(
      'runKineticAnimations',
      this.runKineticAnimations.bind(this),
    );
    global.removeEventListener(
      'mapModalsClosed',
      this.closeMapModals.bind(this),
    );
    global.removeEventListener('keydown', this.handleKeyDown.bind(this));
    global.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  previousStoryline() {
    const { storyline, location, history } = this.props;
    let previous = this.currentStoryline - 1;

    if (previous < 0) {
      previous = this.props.storyline.length - 1;
    }

    this.props.history.push(this.props.storyline[previous].entityUrl.alias);
  }

  nextStoryline() {
    const { storyline, location, history } = this.props;
    let next = this.currentStoryline + 1;

    if (next >= this.props.storyline.length) {
      next = 0;
    }

    this.props.history.push(this.props.storyline[next].entityUrl.alias);
  }

  handleKeyDown(event) {
    if (event.keyCode === 27) {
      global.dispatchEvent(new CustomEvent('closeModal'));
    }
  }

  handleScroll() {
    if (!global.document.body.classList.contains('js-no-scroll')) {
      const scrollDirection = global.scrollY > this.previousScroll;

      if (this.isScrollingUp !== scrollDirection) {
        if (scrollDirection && global.scrollY > 0) {
          // Hide header.
          global.document.documentElement.classList.add('js-scrolled');
        } else {
          // Show header.
          global.document.documentElement.classList.remove('js-scrolled');
        }

        this.isScrollingUp = scrollDirection;
      } else if (
        global.innerHeight + global.scrollY >=
        global.document.body.scrollHeight
      ) {
        // Show the header again once reaching the bottom of the page.
        global.document.documentElement.classList.remove('js-scrolled');
      }

      this.previousScroll = global.scrollY;
    }
  }

  closeModal() {
    const { history, location } = this.props;

    // Check if there is any history to go back to. TODO: This doesn't work if a
    // new tab is opened and a URL with a modal fragment is entered. In that
    // rare case a user when be returned to the empty tab page since the history
    // length would equal 2.
    if (history.length > 1) {
      history.goBack();
    } else {
      // Remove hash from URL.
      history.push(location.pathname);
    }
  }

  closeMapModals() {
    const points = global.document.querySelectorAll('.map__point');

    [].forEach.call(points, el => {
      el.classList.remove('is-active');
    });
  }

  runKineticAnimations() {
    const animationees = global.document.querySelectorAll(
      '.js-kinetic-animation',
    );

    if (animationees.length > 2) {
      [].forEach.call(animationees, el => {
        // Trigger a reflow.
        el.classList.remove('animate--fade-in-up');
        void el.offsetWidth; // eslint-disable-line no-void
        el.classList.add('animate--fade-in-up');
      });
    } else {
      [].forEach.call(animationees, el => {
        el.classList.remove('animate--fade-in-up');
      });
    }
  }

  render() {
    const { storyline, location } = this.props;

    for (let i = 0; i < storyline.length; i += 1) {
      if (storyline[i].entityUrl.alias === location.pathname) {
        this.currentStoryline = i;
        break;
      }
    }

    return null;
  }
}
/* eslint-enable no-unused-vars, class-methods-use-this */

export default StorylineQuery(withRouter(GlobalEvents));



// WEBPACK FOOTER //
// ./screens/App/components/GlobalEvents/index.js